import * as types from "./mutations.types";

export default {
  [types.SET_ANALYZE](state, payload) {
    state.analyze = payload;
  },

  [types.SET_POSITIVE](state, payload) {
    state.positive = payload;
  },

  [types.SET_NEGATIVE](state, payload) {
    state.negative = payload;
  },
  [types.SET_ANALYZE_PRESENTIAL](state, payload) {
    state.analyze_presential = payload;
  }
};
